export default __webpack_public_path__ + "static/media/typeArrow.90e1c901.90e1c901.svg";